import {
  saveAnswer,
} from "./index";
import {startSubmit, stopSubmit} from "redux-form";
import {request} from "../../../utils/api";
import {appKey} from "../../../config";
import {takeEvery, all, put, call} from 'redux-saga/effects';
import getErrorFromResponse from "../../utils/getErrorFromResponse";
import {updateSuccess} from "./index";
import {setNotification} from "../notification";

function* saveAnswerFlow(action) {
  const {key, form, data} = action.payload;
  yield put(startSubmit(form))

  try {
    const response = yield call(() => request.post(`/${appKey}t220r/json/v2`, {
      data: {
        ...data,
        ___parent: key
      }
    }));

    yield put(stopSubmit(form))

    yield put(updateSuccess({
      response: {
        key: key,
        data: {
          custom_последние_ответы: [
            {
              key: response.data.key,
              fields: {
                custom_ответ: data.custom_ответ,
                ___modifieddate: new Date().toISOString(),
              }
            }
          ]
        }
      }
    }));
  } catch (error) {

    if(error?.response?.data?.exception?.type === "SaveNotAllowedException") {
      yield put(setNotification({
        type: "info",
        isInfo: {
          message: "На это обращение ответить нельзя, так как автор его закрыл",
        },
      }))
    }
    else {
      const errors = getErrorFromResponse(error, form)
      yield all(errors)
    }

    yield put(updateSuccess({
      response: {
        key: key,
        data: {
          custom_закрыта: true
        }
      }
    }));
  }
}

export default function* saga() {
  yield all([
    takeEvery(saveAnswer, saveAnswerFlow),
  ])
}